import { isValidUrl } from './is-valid-url'
import { toImageUrl } from './dynamic-image'

function backgroundWidth(size) {
  switch (size) {
    case 'large': {
      return 1200
    }
    case 'medium': {
      return 800
    }
    default: {
      return 500
    }
  }
}

function isPathRelative(url) {
  return url && url.startsWith('/')
}

export function gameInfoBackground(
  backgroundUrl,
  theme,
  dpr,
  imgproxyUrl,
  size,
  hasWebpSupport
) {
  if (!backgroundUrl) {
    return null
  }
  if (!isPathRelative(backgroundUrl) && !isValidUrl(backgroundUrl)) {
    return `url(${theme['bg-pattern-default']}), linear-gradient(to bottom, ${theme.colors['game-info-missing-image-gradient-start']} 2%, ${theme.colors['g-bg']} 73%, transparent)`
  }
  const imageUrl = isPathRelative(backgroundUrl)
    ? toImageUrl(imgproxyUrl, backgroundUrl, {
        dpr,
        resizingWidth: backgroundWidth(size),
        extension: hasWebpSupport ? 'webp' : 'jpg',
      })
    : backgroundUrl

  return `linear-gradient(to bottom, rgba(0,0,0,0.3) 63%, ${theme.colors['g-bg']}), url(${imageUrl})
        `
}
